import { action, observable } from 'mobx'
import { message, Modal } from 'hljd'
import Api from '@api/xiu_yan/serviceAccount'
import { HLJ_MERCHANT_STAFF_MANAGE } from '@constant'
import mStore from '../store'
import { getJti } from '@util'

class Store {
  /*新增客服*/
  @observable isAddModalShow = false // 新建modal模态框显示
  @observable is_edit = false
  @action
  addServiceModal = (record = {}) => {
    if (!record.id) {
      this.params = this.initParams()
      this.is_edit = false
    } else {
      this.is_edit = true
    }
    this.isAddModalShow = !this.isAddModalShow
  }

  serviceManage = () => {
    const url = HLJ_MERCHANT_STAFF_MANAGE + getJti()
    window.open(url)
  }

  handleOk = () => {
    this.form.validateFields(errors => {
      if (!errors) {
        //进行下一步提交：首先验证账户是否已经存在
        let params_submit = Object.assign({}, this.params, {
          confirm: undefined
        })
        if (params_submit && params_submit.id) {
          //编辑
          mStore.modifyRequest(params_submit, this.addServiceModal)
        } else {
          // 新建
          this.addService(params_submit)
        }
      }
    })
  }

  addService = async params_submit => {
    const { msg, RetCode } = await Api.addApi(params_submit)
    if (RetCode == 0) {
      message.success('新建成功~')
      this.addServiceModal() // 隐藏modal
      mStore.$getList(1)
    } else if (RetCode === -2) {
      Modal.warning({
        title: '账号数量超出限制',
        content: msg,
        className: 'beyond-modal'
      })
    } else {
      return message.warning(msg)
    }
  }

  /*form*/
  initParams = (record = {}) => {
    const { password, phone, status, nick, roles, id } = record
    return id
      ? {
          password,
          confirm: '',
          role_ids: roles.map(item => item.id.toString()),
          phone,
          status,
          nick,
          id
        }
      : {
          password: '',
          confirm: '',
          role_ids: ['1', '2'],
          phone: '',
          status: 1,
          nick: ''
        }
  }

  form
  @observable params = this.initParams()
  @observable confirmDirty = false
  formValsChange = (props, values) => {
    this.setParams(values)
  }
  setParams = values => {
    this.params = { ...this.params, ...values }
  }

  // 编辑客服

  editModal = record => () => {
    this.params = this.initParams(record)
    this.addServiceModal(record)
  }
}
export default new Store()
